export default __webpack_public_path__ + "media/images/pages/fitness-shoes-8d7c49542224c14c77fb159063dbf16c.jpg";